import { ComponentRef, ComponentProps } from '../../../interface';

export interface ModalComponent {
  component: ComponentRef,
  componentProps?: ComponentProps,
  element?: HTMLElement
};